import BaseInteractableGeometry from "./base-interactable";

class InteractableCylinder extends BaseInteractableGeometry {
    constructor() {
        super();

        this._height = 1;
        this._radius = 1;

        this.radius = this.height = 1;
    }

    _createMesh() {
        const geometry = new THREE.CylinderBufferGeometry(1, 1, 1, 64, 1);
        const material = new THREE.MeshPhongMaterial({ color: 0xFF4500, transparent: false, opacity: 1 });

        material.emissiveIntensity = 0;
        material.emissive = new THREE.Color(0xFFA500);

        const mesh = new THREE.Mesh(geometry, material);

        mesh.castShadow = true;

        return mesh;
    }

    _createColliders() {
        const { mesh: heightMesh, collider: heightCollider } = this._createAxisCollider({
            axis: new THREE.Vector3(0, 0, 1),
            angle: Math.PI * 0.5,
            interactableType: "height",
            color: 0x0000ff
        });

        const { mesh: radiusMesh, collider: radiusCollider } = this._createAxisCollider({
            halfWidth: true,
            interactableType: "radius",
            color: 0x4169E1
        });

        const { mesh: circumferenceMesh, collider: circumferenceCollider } = this._createRingCollider({
            interactableType: "radius",
            color: 0x4169E1
        });

        const colliders = {
            height: heightCollider,
            radius: radiusCollider,
            circumference: circumferenceCollider
        };

        return { objects: [heightMesh, radiusMesh, circumferenceMesh], colliders, htmls: [] };
    }

    get height() { return this._height; }
    get radius() { return this._radius; }
    get circumference() { return 2 * Math.PI * this._radius; }
    get volume() { return Math.PI * this._height * Math.pow(this._radius, 2); }
    get surfaceArea() { return 2 * Math.PI * this._radius * (this._radius + this._height); }

    get formulas() {
        return [{
            name: "height",
            formula: [{ text: "Height", key: "height" }],
            unit: "cm"
        }, {
            name: "radius",
            formula: [{ text: "Radius", key: "radius" }],
            unit: "cm"
        }, {
            name: "circumference",
            formula: [/*{ text: "2 \u00B7 π \u00B7 " }, { text: "Radius", key: "radius" }*/ { text: "Circumference" }],
            unit: "cm"
        }, /*{
            name: "volume", formula: [
                { text: "π \u00B7 " },
                { text: "Height ", key: "height" },
                { text: "\u00B7 " },
                { text: "Radius²", key: "radius" }
            ], unit: "cm²"
        }, {
            name: "surfaceArea", formula: [
                { text: "2 \u00B7 π \u00B7" },
                {text: " Radius² + Radius \u00B7 Height"}
                // { text: "Radius", key: "radius" },
                // { text: "(" },
                // { text: "Radius", key: "radius" },
                // { text: " + " },
                // { text: "Height", key: "height" },
                // { text: ")" }
            ],
            unit: "cm³"
        }*/];
    }


    set height(v) {
        this._height = Math.max(0.01, v);

        const axes = ["y"];

        this.objects.forEach(o => {
            axes.forEach(axis => {
                o.scale[axis] = this._height;
                o.position[axis] = this._height * 0.5;
            });
        });
    }

    set radius(v) {
        this._radius = Math.max(0.01, v);

        const axes = ["x", "z"];

        this.objects.forEach(o => {
            axes.forEach(axis => {
                o.scale[axis] = this._radius;
            });
        });
    }
}

export default InteractableCylinder;
export { InteractableCylinder };